import React, { useEffect } from 'react';
import { TOKEN_KEY } from '@/common/constant';
import { removeLocalStorageValue } from '@/common/utils';
import { removeXBusinessGuid } from '@/utils/business';

export default function Logout() {
  useEffect(() => {
    removeLocalStorageValue(TOKEN_KEY);
    removeXBusinessGuid();
    setTimeout(() => {
      window.location.href = '/';
    }, 0);
  }, []);

  return <div>Logout...</div>;
}
